// @license Copyright (c) 2017 Copyright Holder All Rights Reserved.
(function () {
	"use strict";

	/*
	Given a 'choice' object and an array of cards, generate a bootstrap dropdown to select the 'next' card for the given choice
	*/

	angular.module("swurveys.maker")
		.directive("swvBranchSelector", Handler)

	function Handler(utilsService) {
		return {
			restrict: 'E',
      scope: {
				swvCards: '&',
				swvChoice: '='
			},
			link : function(scope) {
				scope.id = utilsService.generateUUID();
				//We are manipulating the text of the cards, so make a copy
				scope.cards = angular.copy(scope.swvCards());
				console.log("cards", scope.cards);
				scope.cards.forEach(function(card){
					//Remove the HTML from the cards so they are easier to read
					card.text = card.text.replace(/<[^>]+>/gm, '');
					});

				scope.buttonText = function() {
					var next = scope.swvChoice.next;
					if(next == 'end') return "(End Swurvey)";
					var text = "(No Branching)"
					if(next) text = scope.cards.find(function(card){ if(card.id == next) return true}).text;
					return text;
				}
			},
			template: '\
			<div class="dropdown" >\
			<button class="btn btn-default dropdown-toggle" type="button" id="{{id}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\
				<i class="glyphicon glyphicon-fast-forward" />  {{buttonText()}}\
				<span class="caret"></span>\
			</button>\
			<ul class="dropdown-menu" aria-labelledby="{{id}}">\
				<li ng-click="swvChoice.next = null"><a>(No Branching)</a></li>\
				<li ng-repeat="card in cards"\
					ng-click="swvChoice.next = card.id">\
					<a>{{ card.text }}</a></li>\
				<li ng-click="swvChoice.next = \'end\'"><a>(End Swurvey)</a></li>\
			</ul>\
     </div>'
		}
	}

}());
